import { createFileRoute } from "@tanstack/react-router";
import { NotFoundPage } from "@/components/NotFoundPage";

export const Route = createFileRoute("/404")({
  component: NotFoundPage,
  head: () => ({
    meta: [
      { title: "Seite nicht gefunden – creategy" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "description", content: "Die aufgerufene Seite existiert nicht." },
    ],
  }),
});
